import { HostActionType as e } from "../types/HostActionType.mjs";
import { HostActionIntent as t } from "../types/HostActionIntent.mjs";
import { HostActionFacetKind as n } from "../types/HostActionFacet.mjs";
import { HostActionFigureCaption as r } from "../types/HostActionFigure.mjs";
import { HostActionTargetKind as i } from "../types/HostActionTarget.mjs";
import { getInvitationAmount as a } from "@maat/api-booking/types";
//#region src/mappers/toInvitationActions.ts
var o = (o, s) => o.map((o) => {
	let c = s.get(o.listing_id), l = a(o);
	return {
		id: `${e.InvitationPending}:${o.id}`,
		type: e.InvitationPending,
		intent: t.Waiting,
		imageUrl: c?.image ?? void 0,
		object: c?.listing_title ?? void 0,
		facets: [{
			kind: n.Stay,
			checkIn: o.check_in,
			checkOut: o.check_out
		}],
		figure: l ? {
			amount: l.amount,
			currency: l.currency,
			caption: r.Total
		} : void 0,
		expiresAt: o.expires_at ?? void 0,
		createdAt: o.created_at,
		weight: l?.amount ?? 0,
		target: { kind: i.Messages }
	};
});
//#endregion
export { o as toInvitationActions };
